<!-- user-list.component.html -->
<div class="container-fluid">
  <div class="row justify-content-center">
    <div class="col-lg-10">
      <div class="card">
        <div class="card-body">
          <div class="mb-3 d-flex align-items-center justify-content-between">
            <div class="col">
              <div class="row"> 
                <h4 class="mb-2 fw-bolder">Customer Master </h4>
              </div>
            </div>
            <div class="mb-2">
              <input type="text" placeholder="Search user by name" class="form-control mb-3" [(ngModel)]="searchText" (input)="onSearch()">
            </div>
          </div>
          <button (click)="deleteSelectedEntries()" class="btn btn-outline-danger mb-3"><i class="feather icon-trash-2"></i></button>
          
          <div class="table-responsive">
            <table class="table mb-0 table-centered">
              <thead>
                <tr>
                  <th><input type="checkbox" id="selectAllCheckbox" (change)="selectAllChanged($event)"></th>
                  <th (click)="sortByColumn('clientName')">Name
                    <i class="feather icon-arrow-up" *ngIf="sortColumn === 'clientName' && sortDirection === 'asc'"></i>
                    <i class="feather icon-arrow-down" *ngIf="sortColumn === 'clientName' && sortDirection === 'desc'"></i>
                  </th>
                  <th (click)="sortByColumn('email')">Email
                    <i class="feather icon-arrow-up" *ngIf="sortColumn === 'email' && sortDirection === 'asc'"></i>
                    <i class="feather icon-arrow-down" *ngIf="sortColumn === 'email' && sortDirection === 'desc'"></i>
                  </th>
                  <th (click)="sortByColumn('contactNo')">Phone
                    <i class="feather icon-arrow-up" *ngIf="sortColumn === 'contactNo' && sortDirection === 'asc'"></i>
                    <i class="feather icon-arrow-down" *ngIf="sortColumn === 'contactNo' && sortDirection === 'desc'"></i>
                  </th>
                  <th class="text-end">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let client of paginatedClients">
                  <td><input type="checkbox" class="rowCheckbox" [attr.data-id]="client._id"></td>
                  <td>{{ client.clientName }}</td>
                  <td>{{ client.email }}</td>
                  <td>{{ client.contactNo }}</td>
                  <td class="text-end">
                    <button type="button"  routerLink="/edituserList/{{client._id}}" title="Edit Client Detail"><i class="feather icon-edit"></i>Edit</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          
          <!-- <div class="pagination-container mt-4">
            <div class="datatable-footer-inner selected-count d-flex justify-content-between align-items-center">
              <div class="page-count">
                <p class="font-weight-bold">Showing {{ calculateRangeStart() }} - {{ calculateRangeEnd() }} of {{ totalItems }}</p>
              </div>
      
              <div class="pagination d-flex">
                <a class="pagination-btn pt-2" (click)="onPageChange(currentPage - 1)" [ngClass]="{'disabled': currentPage === 1}">
                  <i class="feather icon-chevrons-left"></i>
                </a>
                <ng-container *ngFor="let page of getNumberRange(getTotalPages())">
                  <a class="pagination-circle" [class.active]="currentPage === page" (click)="onPageChange(page)">
                    {{ page }}
                  </a>
                  <span *ngIf="page < getTotalPages()" class="page-number-space"></span>
                </ng-container>
                <a class="pagination-btn pt-2" (click)="onPageChange(currentPage + 1)" [ngClass]="{'disabled': currentPage === getTotalPages()}">
                  <i class="feather icon-chevrons-right"></i>
                </a>
              </div>
            </div>
          </div> -->

          <div class="pagination-container mt-4">
            <div class="datatable-footer-inner selected-count d-flex justify-content-between align-items-center">
              <div class="page-count">
                <p class="font-weight-bold">Showing {{ calculateRangeStart() }} - {{ calculateRangeEnd() }} of {{ totalItems }}</p>
              </div>
          
              <div class="pagination d-flex">
                <!-- Previous Page Button -->
                <a class="pagination-btn pt-2" (click)="onPageChange(currentPage - 1)" [ngClass]="{'disabled': currentPage === 1}">
                  <i class="feather icon-chevrons-left"></i>
                </a>
          
                <!-- Current Page Number (Only one page visible at a time) -->
                <a class="pagination-circle" [class.active]="true">
                  {{ currentPage }}
                </a>
          
                <!-- Next Page Button -->
                <a class="pagination-btn pt-2" (click)="onPageChange(currentPage + 1)" [ngClass]="{'disabled': currentPage === getTotalPages()}">
                  <i class="feather icon-chevrons-right"></i>
                </a>
              </div>
            </div>
          </div>
          


        </div>
      </div>
    </div>
  </div>
</div>
